import { render } from "./RelatedTour.vue?vue&type=template&id=25d741b6"
import script from "./RelatedTour.vue?vue&type=script&lang=js"
export * from "./RelatedTour.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__